import { create } from 'zustand';

type CepState = {
  cepVia: boolean;
  setCepVia: (data: boolean) => void;
};

export const useCepStore = create<CepState>((set, get) => ({
  cepVia: false,
  setCepVia: data => set(() => ({ cepVia: data })),
  action: () => {
    const data = get().cepVia;
  },
}));
